import * as React from 'react';

import cn from 'classnames';

import { BrandColorValueCmyk } from '../BrandColorValueCmyk';

import { IBrandColorValueProps } from './types';

import * as s from './BrandColorValue.scss';

export const BrandColorValue = ({
	isMainColor,
	title,
	value,
}: IBrandColorValueProps) => {
	return (
		<div className={s.block}>
			<div className={cn(s.title, {
				[s.auxColorTitle]: !isMainColor,
			})}>
				{title.toUpperCase()}
			</div>
			<div className={s.value}>
				{title === 'cmyk'
					? <BrandColorValueCmyk value={value}/>
					: value
				}
			</div>
		</div>
	);
};
